import { call, put, takeLatest } from 'redux-saga/effects';
import { reset } from 'redux-form';
import apiCall from '../helpers/ApiCall';
import { POST } from '../consts/Methods';
import apiRoot from '../consts/apiRoot';
import { POST_NEW_BET, POST_NEW_BET_SUCCESS, POST_NEW_BET_FAIL } from '../redux/OffersDetails';
import track, { events } from '../helpers/track';

function* postNewBetFlow({ payload: { offerId, value, }, }) {
  try {
    const endpoint = `${apiRoot}/offers/${offerId}/bet`;
    const params = { bet: { value, }, };
    track(events.create_bet, { value, offerId, });
    const newBet = yield call(apiCall, { endpoint, params, method: POST, });
    yield put(POST_NEW_BET_SUCCESS(newBet));
    yield put(reset('betsForm'));
  } catch (error) {
    yield put(POST_NEW_BET_FAIL(error));
  }
}

export default function* PostNewBet() {
  yield takeLatest(POST_NEW_BET, postNewBetFlow);
}
